// Provider registry — drives the Integrations forms generically (one screen, N
// providers). Adding a channel adapter is a data change here, not new UI: each
// provider declares its credential fields (secret ones render as password inputs)
// and a docs link. Keep the ids in lockstep with the API's `provider` union
// (api/integrations.ts) and the server-side adapters.
export type ProviderId = "telegram" | "discord" | "whatsapp";

export interface CredField {
  name: string;
  label: string;
  hint?: string;
  secret?: boolean;
}

export interface ProviderMeta {
  id: ProviderId;
  label: string;
  fields: CredField[];
  docsUrl: string;
}

export const PROVIDERS: ProviderMeta[] = [
  {
    id: "telegram",
    label: "Telegram",
    docsUrl: "https://core.telegram.org/bots#botfather",
    fields: [{ name: "botToken", label: "Bot token", hint: "From @BotFather", secret: true }],
  },
  {
    id: "discord",
    label: "Discord",
    docsUrl: "https://discord.com/developers/applications",
    fields: [{ name: "botToken", label: "Bot token", hint: "From the Discord Developer Portal", secret: true }],
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    docsUrl: "https://developers.facebook.com/docs/whatsapp/cloud-api",
    fields: [
      { name: "phoneNumberId", label: "Phone number ID" },
      { name: "accessToken", label: "Access token", secret: true },
      { name: "appSecret", label: "App secret", secret: true },
      { name: "verifyToken", label: "Verify token", secret: true },
    ],
  },
];
